import axios from "axios";
import { OutputBaseProps } from "utils/types/API";

export interface FormStatistical {
    count: number;
}
type ApiFormStatisticalOutputProps = OutputBaseProps<FormStatistical>;

export const apiFormStatistical = async () => {
    const res = (await axios.get<ApiFormStatisticalOutputProps>("/api/statistical/form"))
        .data;
    return res;
};